import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

/**
 * Navigates to a URL when React Router is not available in the current context.
 * Use this helper when you need to perform navigation on event handlers in React components.
 * Solves the issue of assigning window.location.href in component event handlers causing "linter perceived" side effects.
 *
 * @param url - The destination URL to navigate to, if the URL is invalid, it will not navigate
 * @param replace - When true, replaces the current history entry instead of adding a new one.
 *                 Defaults to false which adds a new history entry.
 *
 * @example
 * // Navigate to a new URL, adding to history
 * navigateWithoutRouter('/some/path');
 *
 * // Replace current URL in history
 * navigateWithoutRouter('/some/path', true);
 */

export const navigateWithoutRouter = (url: string, replace: boolean = false) => {
  if (isSSR()) {
    // eslint-disable-next-line no-console
    console.warn("navigateWithoutRouter is not available in SSR");

    return;
  }
  if (!url) {
    return;
  }

  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};
